module.exports = "https://redage.akamaized.net/src/views/games/other/images/maps/tanks1.png";